export const DataStorage = {
    lastBlock: {
        'THOR': 0,
    },
    lastNodes: []
}
